import { Injectable } from '@angular/core';
import { IMaintenanceConfig } from 'avn/modules/services/maintenance.service';
import { Location } from 'avn/modules/shared/interfaces/homepage';
import * as CryptoJS from 'crypto-js';
import moment from 'moment';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  public meraLocation: any = new Location();

  public meraLocationSub = new BehaviorSubject<Location>(this.getmeraLocation());
  public meraLocationSubject = this.meraLocationSub.asObservable().pipe(distinctUntilChanged());

  public fetchmeraLocation = new Subject<any>();

  public searchBoxParams = new Subject<any>();

  public headerCategories: any = {};
  public healthConditionList: any[] = [];

  public homePageSearchServices: any[] = [];

  public currentPageType = new Subject<any>();

  public maintenanceConfig: IMaintenanceConfig = {
    maintenance: { show: false },
    banner: { show: false },
    repeat: false
  };

  public setmeraLocation(location: Location): void {
    this.meraLocation = location;
    const regex = new RegExp(/^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/);
    if (this.meraLocation.post_code && !regex.test(this.meraLocation.post_code)) {
      this.setDefaultLocation();
      return;
    }
    this.meraLocationSub.next(location);
    try {
      localStorage.setItem('meraLocation', JSON.stringify(location));
    } catch {
      console.info('localStorage error');
    }
  }

  public setDefaultLocation(): void {
    const location = this.meraLocation;
    location.city_name = 'Sydney';
    location.post_code = '2000';
    location.lng = '151.2092955';
    location.lat = '-33.8688197';
    location.state_name = 'New South Wales';
    this.setmeraLocation(location);
  }

  public getmeraLocation(): Location {
    try {
      if (this.meraLocation?.city_name) {
        // Already set — nothing to do here, fall through to the return below.
      } else if (localStorage.getItem('meraLocation')) {
        this.meraLocation = JSON.parse(localStorage.getItem('meraLocation') || '');
        this.setmeraLocation(this.meraLocation);
      } else {
        this.meraLocation = new Location();
      }
      return this.meraLocation;
    } catch {
      console.info('local storage error: IGNORE');
      return this.meraLocation;
    }
  }

  public getRandomNumber(time = false): string {
    if (time) {
      return moment().format('YYYYMMDDhhmmss');
    }
    return moment().format('YYYYMMDD');
  }

  public generateHmac(data: string, secretKey: string): string {
    return CryptoJS.HmacSHA256(data, secretKey).toString(CryptoJS.enc.Hex);
  }

  public showBannerMaintenance(): boolean | undefined {
    const bannerConfig = this.maintenanceConfig.banner;
    const isActiveByTime = this.isMaintenanceActive(bannerConfig);
    const isActiveByRole = bannerConfig.applied_for?.all;

    return isActiveByTime && isActiveByRole;
  }

  public isMaintenanceActive(config: any): boolean {
    if (!config?.show) {
      return false;
    }

    const now = moment();
    const startDate =
      config?.start_time && moment(config.start_time, 'YYYY-MM-DD hh:mm A ZZ', true).isValid()
        ? moment(config.start_time, 'YYYY-MM-DD hh:mm A ZZ', true)
        : null;
    const endDate =
      config?.end_time && moment(config.end_time, 'YYYY-MM-DD hh:mm A ZZ', true).isValid()
        ? moment(config.end_time, 'YYYY-MM-DD hh:mm A ZZ', true)
        : null;

    if (startDate && endDate) {
      return now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate);
    }

    if (startDate) {
      return now.isSameOrAfter(startDate);
    }

    if (endDate) {
      return now.isSameOrBefore(endDate);
    }

    return true;
  }
}
